/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
export class LoaderTask {
    constructor(parentTask) {
        this.parentTask = parentTask;
    }
    get stepCalculation() {
        var keys = Object.keys(this.steps);
        var arr = keys.map(k => this.steps[k]);
        return {
            total: arr.length,
            completed: arr.filter(item => item).length
        };
    }
    get taskCalculation() {
        return {
            total: this.tasks.length,
            completed: this.tasks.filter(t => t.complete).length
        };
    }
    calculate() {
        var steps = this.steps ? this.stepCalculation : null;
        var tasks = this.tasks ? this.taskCalculation : null;
        var total = (steps ? steps.total : 0) + (tasks ? tasks.total : 0);
        var completed = (steps ? steps.completed : 0) + (tasks ? tasks.completed : 0);
        this.progress = completed / total;
        if (this.progress >= 1) {
            this.complete = true;
        }
        if (this.parentTask) {
            this.parentTask.calculate();
        }
    }
}
export class Loader {
    constructor() {
        this.task = new LoaderTask();
        // this.emitter = new mitt<any>();
    }
    get progress() {
        return this.task.progress;
    }
    get complete() {
        return this.task.complete;
    }
    addSteps(steps) {
    }
    taskByName(name) {
        if (this.task.tasks) {
            return this.task.tasks.find(t => t.name === name);
        }
        else {
            return undefined;
        }
    }
    updateProgress(progress, name) {
        var task;
        if (!name) {
            task = this.task;
        }
        else {
            task = this.taskByName(name);
        }
        task.progress = progress;
        task.calculate();
    }
    completeStep(stepName, taskName) {
        var task;
        if (!taskName) {
            task = this.task;
        }
        else {
            task = this.taskByName(taskName);
        }
        task.steps[stepName] = true;
        task.calculate();
    }
}
//# sourceMappingURL=loader.js.map